module.exports = __webpack_public_path__ + "static/tablet-57caab0059991914ba89a75c7e6b069c.jpg";